import { render, staticRenderFns } from "./app3.vue?vue&type=template&id=db45669a"
import script from "./app3.vue?vue&type=script&lang=js"
export * from "./app3.vue?vue&type=script&lang=js"
import style0 from "./app3.vue?vue&type=style&index=0&id=db45669a&prod&lang=scss"
import style1 from "./app3.vue?vue&type=style&index=1&id=db45669a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports